(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    // ZERANCE - Guide des tailles : ouverture / fermeture de la popup
  if (!window.__zrSizeGuideInit) {
    window.__zrSizeGuideInit = true;

    const closeAll = () => {
      document.querySelectorAll('.size-guide:not([hidden])').forEach((modal) => {
        modal.hidden = true;
      });
      document.body.classList.remove('size-guide-open');
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-size-guide-open]');
      if (opener) {
        event.preventDefault();
        const id = opener.getAttribute('data-size-guide-open');
        const modals = document.querySelectorAll('[id="' + id + '"]');
        if (!modals.length) return;
        const modal = modals[0];
        // Un seul exemplaire, deplace dans le body pour eviter tout parent avec transform
        modals.forEach((el) => { if (el !== modal) el.remove(); });
        if (modal.parentElement !== document.body) document.body.appendChild(modal);
        modal.hidden = false;
        document.body.classList.add('size-guide-open');
        const closeBtn = modal.querySelector('.size-guide__close');
        if (closeBtn) closeBtn.focus();
        return;
      }
      if (event.target.closest('[data-size-guide-close]')) {
        event.preventDefault();
        closeAll();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
